export default {
      id: "menu__maintenance_fill-usage",
      viewBox: "0 0 31 31",
      url: __webpack_public_path__ + "img/icons.svg#menu__maintenance_fill",
      toString: function () {
        return this.url;
      }
    }